import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const PostDeploymentModuleCalldataSchema = z.object({
  postDeploymentModuleCalldataValue: z.instanceof(HexNumber),
})

type PostDeploymentModuleCalldataProps = z.infer<
  typeof PostDeploymentModuleCalldataSchema
>

export class PostDeploymentModuleCalldata extends ValueObject<PostDeploymentModuleCalldataProps> {
  public getValue(): HexNumber {
    return this.props.postDeploymentModuleCalldataValue
  }

  public static create(
    props: PostDeploymentModuleCalldataProps
  ): PostDeploymentModuleCalldata {
    const validatedProps = PostDeploymentModuleCalldataSchema.parse(props)
    return new PostDeploymentModuleCalldata(validatedProps)
  }
}
